import { render, staticRenderFns } from "./AddEditNotification.vue?vue&type=template&id=77613ac5&scoped=true"
import script from "./AddEditNotification.vue?vue&type=script&lang=js"
export * from "./AddEditNotification.vue?vue&type=script&lang=js"
import style0 from "./AddEditNotification.vue?vue&type=style&index=0&id=77613ac5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77613ac5",
  null
  
)

export default component.exports